import { useTranslationWithSelfFallback } from '@i18n/useTranslationWithSelfFallback';
import Image from 'next/image';
import { ArrowRight, CaretRight } from '@phosphor-icons/react';
import {
  MegaMenuLevels,
  trackMegaMenuNavigation,
  isModifiedClick,
} from '_utils/GA4/trackMegaMenuEvents';
import { FeatureCard } from '../FeatureCard';
import { useMegaMenuMobile } from '@hooks/useMegaMenuMobile';
import { MENU_PATH_DELIMITER } from '_utils/GA4/trackMegaMenuEvents';
import styles from './Mobile.module.scss';

export function CategoryPanel() {
  const { activeItem, handleBack, handleClose, handleColumnClick } =
    useMegaMenuMobile();
  const t = useTranslationWithSelfFallback('common');
  return (
    <div className={styles.Panel} role="group" aria-label={activeItem?.label}>
      <div className={styles.BackSection}>
        <button className={styles.BackLink} onClick={handleBack}>
          {t('header.menu.back')}
        </button>
        {activeItem &&
          activeItem.title?.label &&
          (activeItem.title.url ? (
            <a
              href={activeItem.title.url}
              className={styles.PanelTitle}
              onClick={(e) => {
                if (!activeItem || !activeItem.title) return;
                const navProps = {
                  level: MegaMenuLevels.level_2,
                  linkUrl: activeItem.title.url,
                  linkText: activeItem.title.label,
                  menuPath: `${activeItem.label}${MENU_PATH_DELIMITER}${activeItem.title.label}`,
                };
                if (isModifiedClick(e)) {
                  trackMegaMenuNavigation(navProps);
                  return;
                }
                e.preventDefault();
                const { url } = activeItem.title;
                trackMegaMenuNavigation({
                  ...navProps,
                  eventCallback: () => {
                    window.location.href = url;
                  },
                });
                handleClose();
              }}
            >
              {activeItem.title.label}
              <ArrowRight size={24} />
            </a>
          ) : (
            <span className={styles.PanelTitle}>{activeItem.title.label}</span>
          ))}
      </div>
      <div className={styles.LinksSection}>
        <hr className={styles.Divider} />
        {activeItem?.topBrandIcons && activeItem.topBrandIcons.length > 0 && (
          <>
            <div className={styles.TopBrands}>
              {activeItem.topBrandIconsTitle && (
                <span className={styles.TopBrandsTitle}>
                  {activeItem.topBrandIconsTitle}
                </span>
              )}
              <div className={styles.TopBrandsGrid}>
                {activeItem.topBrandIcons.map((icon) => (
                  <a
                    key={icon.url}
                    href={icon.url}
                    className={styles.TopBrandIconItem}
                    onClick={(e) => {
                      const navProps = {
                        level: MegaMenuLevels.level_4,
                        linkUrl: icon.url,
                        linkText: null,
                        menuPath: `${activeItem.label}${MENU_PATH_DELIMITER}${
                          icon.alt ?? ''
                        }`,
                      };
                      if (isModifiedClick(e)) {
                        trackMegaMenuNavigation(navProps);
                        return;
                      }
                      e.preventDefault();
                      trackMegaMenuNavigation({
                        ...navProps,
                        eventCallback: () => {
                          window.location.href = icon.url;
                        },
                      });
                      handleClose();
                    }}
                  >
                    <Image
                      src={icon.logo}
                      alt={icon.alt ?? ''}
                      width={128}
                      height={64}
                      className={styles.TopBrandIconImage}
                    />
                  </a>
                ))}
              </div>
            </div>
            <hr className={styles.Divider} />
          </>
        )}
        <ul className={styles.List}>
          {activeItem &&
            activeItem.linkColumns?.map((column) => (
              <li key={column.title} className={styles.ListItem}>
                <button
                  className={styles.Row}
                  onClick={() => {
                    trackMegaMenuNavigation({
                      level: MegaMenuLevels.level_3,
                      linkUrl: null,
                      linkText: column.title,
                      menuPath: `${activeItem.label}${MENU_PATH_DELIMITER}${column.title}`,
                    });
                    handleColumnClick(column);
                  }}
                >
                  {column.title}
                  <CaretRight size={20} />
                </button>
              </li>
            ))}
        </ul>
      </div>
      {activeItem?.featureCard && (
        <div className={styles.FeatureCardWrapper}>
          <FeatureCard
            card={activeItem.featureCard}
            menuPathPrefix={activeItem.label}
          />
        </div>
      )}
    </div>
  );
}
